import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export enum Size {
  Small = 'sm',
  Default = 'default'
}

@Component({
  selector: 'form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements OnInit {
  public readonly Size = Size;

  @Input() label: string;
  @Input() error: string;
  @Input() isError: boolean;
  @Input() hint: string;
  @Input() info: string;
  @Input() infoLink: string[] | string;
  @Input() infoEvent: any[];
  @Input() suffix: string;
  @Input() size: Size = Size.Default;

  @Input() help = false;
  @Output() helpClicked = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  onHelpClick() {
    this.helpClicked.emit();
  }
}
